export default {
    welcome: 'Willkommen auf der Seite!',
    message: 'Dies ist eine Nachricht auf Deutsch.',
    application: 'Bewerbung',
    language: 'Sprache',
    heroEyebrow: 'Bewerbung · Online-Formular',
    heroTitle: 'Ihr Platz für das kommende Semester beginnt hier',
    heroDescription: 'Füllen Sie die folgenden Angaben aus, um sich für Ihre Kurse anzumelden. Alle Angaben finden Sie auf dieser einen Seite.',

    // بخش‌ها
    personalInformation: 'Persönliche Angaben',
    personalInformationDescription: 'Ihre Kontakt- und Anschriftdaten für die Bewerbung.',
    degreeEducation: 'Abschluss / Ausbildung',
    theologicalEducation: 'Theologische Ausbildung (falls vorhanden; freiwillige Angabe)',
    spouse: 'Ehepartner/in',
    studyForm: 'Studienform',
    studyFormDescription: 'Wählen Sie die für Sie passende Form des Studiums.',
    participationType: 'Art Der Teilname',
    moduleSelection: 'Modulauswahl',
    documents: 'Unterlagen (erlaubte Dateien: .pdf .jpg .jpeg .png .doc .docx)',
    Certificates: 'Zeugnisse (Abitur, Bachelor etc.) ',
    furtherQuestion: 'Weitere Fragen',
    consentNewsletter: 'Datenschutz & Newsletter',
    Courses:'Kurse',
    otherCourses:'Andere Kurse',
    coursesFromOtherTerms:'Kurse aus anderen Semestern',
    courseLimitDescription: 'Die aktuellen Kurse dieses Semesters. Sie können insgesamt maximal {max} Kurse wählen.',
    courseLimitReached: 'Sie haben die maximale Anzahl von {max} Kursen erreicht. Entfernen Sie einen Kurs, um einen anderen zu wählen.',
    coursesSelected: '{count} ausgewählt',
    noCoursesSelected: 'keine ausgewählt',
    semester: 'Semester',

    // Personal Information
    sex: 'sex',
    firstName: 'Vorname',
    lastName: 'Nachname',
    street: 'Straße',
    houseNumber: 'Hausnummer',
    postalCode: 'Postleitzahl',
    city: 'Stadt',
    phoneNumber: 'Telefonnummer',
    email: 'E-Mail',
    dateOfBirth: 'Geburtsdatum',
    placeOfBirth: 'Geburtsort',
    maritalStatus: 'Familienstand',
    nationality: 'Staatsangehörigkeit',
    denomination: 'Konfession',
    fathersFirstName: 'Vorname des Vaters',
    fathersLastName: 'Nachname des Vaters',
    fathersNationality: 'Staatsangehörigkeit des Vaters',

    // Degree / Education
    diploma: 'Abschluss',
    specialization: 'Fachrichtung',
    placeOfTraining: 'Ort der Ausbildung',
    graduationYear: 'Abschlussjahr',
    thesisGrade: 'Note der Abschlussarbeit',

    // Theological Education
    institution: 'Institut',
    level: 'Stufe',
    theologyGraduationYear: 'Abschlussjahr (Theologie)',
    additionalTraining: 'Weitere Ausbildung',
    NameOfTheSchool:'Name der Schule',
    DurationOfTraining:'Dauer der Ausbildung',

    // Spouse
    spouseTitle: 'Anrede Ehepartner/in',
    spouseFirstName: 'Vorname Ehepartner/in',
    spouseLastName: 'Nachname Ehepartner/in',
    spouseNationality: 'Staatsangehörigkeit Ehepartner/in',
    spouseDenomination: 'Konfession Ehepartner/in',
    spouseProfession: 'Beruf Ehepartner/in',

    // Study Form
    fullTime: 'Vollzeit',
    fullTimeDescription: 'Volles Kursprogramm mit regelmäßiger Anwesenheit.',
    partTime: 'Teilzeit',
    partTimeDescription: 'Reduzierter Stundenumfang neben Beruf oder Studium.',
    guestStudentStatus: 'Gasthörerstatus',
    guestStudentStatusDescription: 'Freie Teilnahme, wahlweise mit oder ohne Prüfung und Teilnahmezertifikat.',
    GuestStudentshipWithCertificate:'Gaststudium mit Zeugnis',
    GuestStudentStatusWithoutCertificate:'Gasthörerstatus ohne Zeugnis',
    distanceLearning: 'Fernstudium',
    block: 'Blockveranstaltung',
    intensiveCourse: 'Intensivkurs',

    // Participation Type
    online: 'Online',
    offline: 'Offline',

    foundationsOfBelief3: "Überzeugungsgrundlagen III",
    wordsOfQuranAndRoots3: "Die Worte des Korans und ihre Wurzeln III",
    logic2: "Logik (Mantiq) II",
    islamicLegalProvisions3: "Alltagspraktische islamische Rechtsbestimmungen III",
    introQuranicStudies: "Einführung in die Koranwissenschaften",
    recitationIntonationQuran1: "Rezitation und Intonation des Korans I",
    introIslamicLegalNorms: "Einführung in die Verständnisgrundlagen der islamischen Rechtsnormenlehre",

    // Documents
    Passport: 'Kopie vom Pass oder Personalausweis',
    certificate: 'Zeugnis',
    photo: 'Foto',
    cv: 'Lebenslauf',

    // Further Questions
    messageOrQuestion: 'Ihre Nachricht oder Frage...',
    copyOfPassportOrId: "Copy of passport or identity card",
    biometricPhoto: "Biometrisches Foto",
    furtherQuestions: "Sie haben noch weitere Fragen an uns?",
    consentAndNewsletter: "Einwilligung & Newsletter",
    // Consent & Newsletter
    consent: 'Ich stimme zu, dass meine Angaben gespeichert werden, um meine Anfrage zu bearbeiten.',
    newsletter: 'Ich möchte den Al-Mustafa Newsletter abonnieren.',
    submit: 'Bewerbung absenden',

    // Validation
    pleaseFill: 'Dieses Feld muss ausgefüllt werden.',
    ChooseFile:'Datei auswählen',
    PleaseSelectOne:'Bitte wählen Sie mindestens einen Kurs aus',
    passport_required: "Bitte laden Sie Ihren Reisepass hoch.",
    certificate_required: "Bitte laden Sie Ihr Zertifikat hoch.",
    photo_required: "Bitte laden Sie Ihr biometrisches Foto hoch.",
    cv_required: "Bitte laden Sie Ihre Lebenslauf-Datei hoch.",
    agreeInfoStorage: 'Ich bin damit einverstanden, dass die von mir übermittelten Informationen gespeichert werden, damit meine Anfrage beantwortet werden kann.',
    course: 'Kurs',
    studentInitialPayment: 'Sie sind Student*in. Die Anzahlung von 450 € wurde angewendet.',
    regularPrice: 'Regulärer Preis (Nicht-Student*in)',
    mode: 'Modus',
    duration: 'Dauer',
    paymentType: 'Zahlungsart',
    paymentTypeDescription: 'Wählen Sie Ihr Zahlungsmodell. Der Gesamtbetrag überschreitet niemals die dafür geltende Preisobergrenze.',
    yourPrice: 'Ihr Preis',
    priceForCourses: 'für {count} ausgewählte Kurse',
    individualPriceTotal: 'Einzelpreise zusammen',
    packageSaving: 'Paketpreis: Sie sparen {amount}',
    priceCapNote: 'Summe Ihrer Kurspreise. Mehr als {cap} zahlen Sie nie – ab diesem Betrag gilt der Paketpreis.',
    basePrice: 'Grundpreis',
    paymentOffline: 'Zahlung offline',
    // paypalInstruction: 'Bitte überweisen Sie den Betrag auf folgendes PayPal-Konto:',
    paypalInstruction: 'Bitte überweisen Sie den Betrag auf folgendes Konto:',
    payNow: 'Jetzt bezahlen',
    agreeAndPay: 'Kostenpflichtig zustimmen',
    cancel: 'Abbrechen',
    closes: 'Schließen',
    price: 'Preis',
    action: 'Aktion',
      installment: 'Ratenzahlung',
      selectCoursesToAdd: 'Kurse zum Hinzufügen auswählen',
    courseName: 'Kursname',
    orderSummaryPayment: 'Bestellübersicht & Zahlung',
    yourMessageOrQuestion: 'Ihre Nachricht oder Frage...',
    areYouAStudent: 'studierst du in Al Mustafa?',
    yes: 'Ja',
    no: 'Nein',
    onlineTotal: 'Online-Gesamtsumme:',
    offlineTotal: 'Offline-Gesamtsumme:',
    grandTotal: 'Gesamtsumme:',
    paymentSuccessful: 'Zahlung erfolgreich',
    paymentFailed: 'Zahlung fehlgeschlagen',
    amount: 'Betrag',
    referenceId: 'Referenznummer',
    description: 'Beschreibung',
    something_went_wrong:'etwas ist schiefgelaufen',
    file_too_large:'Die Datei {name} ist größer als 2 MB.',
    request_too_large:'Die hochgeladene Datei ist zu groß. Jede Datei darf höchstens 2 MB groß sein.',
    session_expired:'Ihre Sitzung ist abgelaufen. Bitte senden Sie das Formular erneut ab.',
    invalidEmail:'Ungültige E-Mail-Adresse',
    Nameoftheschool:"Name der Schule",
    title: "Anrede",
    Mister: "Herr",
    Woman: "Frau",
    SelectPlaceHolder:"Auswählen...",
    PleaseInput: "Bitte Eingeben",
    SelectDate:"Datum auswählen",
    Delete:"Löschen",
    "part-time": 'Teilzeit',
    "full-time": 'Vollzeit',
    courseType:"Kursarten ist {type}",
    paymentTypeis:"Zahlungsverlaufsart ist {type}",
    Unique:'Einmalig',
    directDebit:'SEPA-Lastschriftmandat',
    accountHolder:'Kontoinhaber/in',
    directDebitMandate:'Ich ermächtige das Ereignis gGmbH, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von dem Ereignis gGmbH auf mein Konto gezogenen Lastschriften einzulösen.',
    noticeDebit:'Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.',
    agreeDebit:'Ich stimme den Bedingungen zu.',
    emailwassuccessfullysent:"E-Mail wurde erfolgreich gesendet ✅",
    emailwasnotsent:"E-Mail wurde nicht gesendet ❌",
    Online:"Online"

    ,
    // reCAPTCHA
    recaptcha_failed_to_load: 'Captcha konnte nicht geladen werden. Bitte Seite aktualisieren.',
    recaptcha_placeholder_not_found: 'Captcha-Platzhalter nicht gefunden.',
    recaptcha_placeholder_not_found_in_time: 'Captcha-Platzhalter nicht rechtzeitig gefunden.',
    recaptcha_please_check: 'Bitte „Ich bin kein Roboter“ auswählen.',
    recaptcha_failed_render_modal: 'Captcha im Modal konnte nicht gerendert werden.',
    recaptcha_please_complete: 'Bitte das Captcha ausfüllen.',
    recaptcha_verification_failed: 'Das Captcha ist abgelaufen oder wurde bereits verwendet. Bitte bestätigen Sie es erneut.'



}
